<div class="ui-g-4">
  <div class="flex-start-center font-13 font-600">
    <p class="text-truncate m-0" tooltipPosition="top" [pTooltip]="helperService.getLocalizationValue(currentLang, service , 'title')">{{ helperService.getLocalizationValue(currentLang, service , 'title') }}</p>
    <p *ngIf="isServiceAssignDisabled" class="capitalize m-0">&nbsp;({{serviceAuthConsts[service?.serviceStatus]}})</p>
  </div>
</div>

<div class="ui-g-2">
  <p class="m-0 font-13">{{workStateTitle[service?.status]}}</p>
</div>

<!-- Primary technician -->
<div class="ui-g-2 flex-column flex-center-start multi-tech-row">
  <app-dropdown *ngIf="service?.tech?.workStatus !== 'inprogress'" theme="light" placeholder="Primary tech"
    field="name" class="width-100p" styleClassValue="pl-0" styleClassSelectedView="pl-0"
    styleClassDropdownListItem="p-0" itemWidth="250px" inactiveItemsKey="isActive" scrollHeight="222px"
    [selectInactiveItems]="false" [hasError]="errors?.tech" [fullyControlled]="true"
    [disabled]="isServiceAssignDisabled" [options]="_technicians" [value]="currentTech?.tech" [fontSize]="13"
    [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true" [setPositionDynamically]="true"
    (appSelect)="handleTechSelect('tech', $event)">
    <ng-template let-item appTemplate="item">
      <div class="tech-item flex-between-center font-13" tooltipPosition="top" [ngClass]="{'disabled': !item.isActive}"
        [pTooltip]="item?.disabledTooltip">
        <div class="flex-start-center">
          <span *ngIf="item?.techId !== 'unassigned'" class="tech-initials flex-center-center mr-1">
            {{techInitials[item.techId]?.initials || item.initials}}
          </span>

          <span *ngIf="item?.techId === 'unassigned'" class="tech-initials flex-center-center mr-1">
            <i class="far fa-user-hard-hat"></i>
          </span>

          <span class="text-truncate">
            {{techInitials[item.techId]?.name || item.name}}
          </span>
        </div>

        <span [class]="item?.workStatus? 'visible' : 'invisible'">
          <img class="work-state-icon" [src]="workStateIcon[item?.workStatus]" [alt]="workStateIcon[item?.workStatus]">
        </span>
      </div>
    </ng-template>
  </app-dropdown>

  <div *ngIf="service?.tech?.workStatus === 'inprogress'" class="cannot-reassign font-red font-13">
    Cannot reassign
  </div>

  <div class="flex-start-center font-11 font-gray-35" tooltipPosition="top" [pTooltip]="service?.tech?.tooltip"
    [escape]="false">
    <img *ngIf="service?.tech?.techId" class="work-state-icon"
      [src]="workStateIcon[service?.tech?.workStatus || service?.status]" [alt]="workStateTitle[service?.status]">
    <span>{{service?.tech?.name || 'Not assigned'}}</span>
  </div>
</div>

<!-- Helper 1 Technician -->
<div class="ui-g-2 flex-column flex-center-start">
  <app-dropdown *ngIf="service?.hTechOne?.workStatus !== 'inprogress'" theme="light" placeholder="Helper 1"
    field="name" class="width-100p" styleClassValue="pl-0" styleClassSelectedView="pl-0"
    styleClassDropdownListItem="p-0" itemWidth="250px" inactiveItemsKey="isActive1" scrollHeight="222px"
    [selectInactiveItems]="false" [hasError]="errors?.hTechOne" [fullyControlled]="true"
    [disabled]="isServiceAssignDisabled || (!currentTech?.tech?.techId && !currentTech?.hTechOne?.techId) || currentTech?.hTechOne?.workStatus === 'inprogress'"
    [options]="_technicians" [value]="currentTech?.hTechOne" [fontSize]="13" [isDropdownIconVisible]="true"
    [hasCustomItemTemplate]="true" [setPositionDynamically]="true" (appSelect)="handleTechSelect('hTechOne', $event)">
    <ng-template let-item appTemplate="item">
      <div class="tech-item flex-between-center font-13" tooltipPosition="top" [ngClass]="{'disabled': !item.isActive1}"
        [pTooltip]="item?.disabledTooltip">
        <div class="flex-start-center">
          <span *ngIf="item?.techId !== 'unassigned'" class="tech-initials flex-center-center mr-1">
            {{techInitials[item.techId]?.initials || item.initials}}
          </span>

          <span *ngIf="item?.techId === 'unassigned'" class="tech-initials flex-center-center mr-1">
            <i class="far fa-user-hard-hat"></i>
          </span>

          <span class="text-truncate">
            {{techInitials[item.techId]?.name || item.name}}
          </span>
        </div>

        <span [class]="item?.workStatus? 'visible' : 'invisible'">
          <img class="work-state-icon" [src]="workStateIcon[item?.workStatus]" [alt]="workStateIcon[item?.workStatus]">
        </span>
      </div>
    </ng-template>
  </app-dropdown>

  <div *ngIf="service?.hTechOne?.workStatus === 'inprogress'" class="cannot-reassign font-red font-13">
    Cannot reassign
  </div>

  <div class="flex-start-center font-11 font-gray-35" tooltipPosition="top" [pTooltip]="service?.hTechOne?.tooltip"
    [escape]="false">
    <img *ngIf="service?.hTechOne?.techId" class="work-state-icon" [src]="workStateIcon[service?.hTechOne?.workStatus]"
      [alt]="workStateTitle[service?.status]">
    <span>{{service?.hTechOne?.name || 'Not assigned'}}</span>
  </div>
</div>

<!-- Helper 2 Technician -->
<div class="ui-g-2 flex-column flex-center-start">
  <app-dropdown *ngIf="service?.hTechTwo?.workStatus !== 'inprogress'" theme="light" placeholder="Helper 2"
    field="name" class="width-100p" hPosition="left" styleClassValue="pl-0" styleClassSelectedView="pl-0"
    styleClassDropdownListItem="p-0" itemWidth="250px" inactiveItemsKey="isActive2" scrollHeight="222px"
    [selectInactiveItems]="false" [hasError]="errors?.hTechTwo" [fullyControlled]="true" [options]="_technicians"
    [value]="currentTech?.hTechTwo" [fontSize]="13"
    [disabled]="isServiceAssignDisabled || (!currentTech?.hTechOne?.techId && !currentTech?.hTechTwo?.techId) || currentTech?.hTechTwo?.workStatus === 'inprogress'"
    [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true" [setPositionDynamically]="true"
    (appSelect)="handleTechSelect('hTechTwo', $event)">
    <ng-template let-item appTemplate="item">
      <div class="tech-item flex-between-center font-13" tooltipPosition="top" [ngClass]="{'disabled': !item.isActive2}"
        [pTooltip]="item?.disabledTooltip">
        <div class="flex-start-center">
          <span *ngIf="item?.techId !== 'unassigned'" class="tech-initials flex-center-center mr-1">
            {{techInitials[item.techId]?.initials || item.initials}}
          </span>

          <span *ngIf="item?.techId === 'unassigned'" class="tech-initials flex-center-center mr-1">
            <i class="far fa-user-hard-hat"></i>
          </span>

          <span class="text-truncate">
            {{techInitials[item.techId]?.name || item.name}}
          </span>
        </div>

        <span [class]="item?.workStatus? 'visible' : 'invisible'">
          <img class="work-state-icon" [src]="workStateIcon[item?.workStatus]" [alt]="workStateIcon[item?.workStatus]">
        </span>
      </div>
    </ng-template>
  </app-dropdown>

  <div *ngIf="service?.hTechTwo?.workStatus === 'inprogress'" class="cannot-reassign font-red font-13">
    Cannot reassign
  </div>

  <div class="flex-start-center font-11 font-gray-35" tooltipPosition="top" [pTooltip]="service?.hTechTwo?.tooltip"
    [escape]="false">
    <img *ngIf="service?.hTechTwo?.techId" class="work-state-icon" [src]="workStateIcon[service?.hTechTwo?.workStatus]"
      [alt]="workStateTitle[service?.status]">
    <span>{{service?.hTechTwo?.name || 'Not assigned'}}</span>
  </div>
</div>
